import { Dispatch } from 'redux';
import fetchApi from '../services/api';
import * as types from './actionTypes';

/**
 * Submit a contact email
 */
export function submitContactForm(values: {}) {
  return async (dispatch: Dispatch<any>) => {
    dispatch({
      type: types.ClearMessages,
    });
    try {
      const response = await fetchApi('/contact-na', values, 'post');
      const json = await response.json();
      if (response.ok) {
        return dispatch({
          messages: [json],
          type: types.ContactFormSuccess,
        });
      }
      return dispatch({
        messages: [json],
        type: types.ContactFormFailure,
      });
    } catch (error) {
      dispatch({
        error,
        type: types.GenericError,
      });
    }
  };
}

/**
 * Request Agent to call back immediately
 * @param {string} token
 * @returns
 */
export function requestAgentCall(token: string) {
  return async (dispatch: Dispatch<any>) => {
    try {
      const response = await fetchApi(
        `/request-agent-call`,
        { subject: 'call me now' },
        'post',
        {},
        token,
      );
      if (response.ok) {
        return dispatch({
          type: types.AgentCallRequestSuccess,
        });
      } else {
        return dispatch({
          type: types.AgentCallRequestFailure,
        });
      }
    } catch (error) {
      dispatch({
        error,
        type: types.GenericError,
      });
    }
  };
}
